import { memo } from 'react';
import { IPlayer } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import {
    Element,
    Level,
    List,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';

export function BenchesList({ players = [] }: any) {
    const benchPlayer = players.filter((player: IPlayer) => {
        return ArrayUtils.isEmpty(player.events || []);
    });

    return (
        <List className={styles['column-list']}>
            {benchPlayer?.map((player: any, index: number) => {
                return (
                    <List.Item key={index}>
                        <Level>
                            <Level.Side align="left">
                                <RouterLink
                                    to={`${URL_SOCCER_PAGE.SUBPATH}${player.path}`}
                                    title={player.name}
                                >
                                    <Avatar
                                        avatar={player.avatar}
                                        name={player.name}
                                    />
                                    <Element className={styles['player-info']}>
                                        {player.shirtNumber > 0 && (
                                            <Element
                                                className={styles['shirt']}
                                            >
                                                {player.shirtNumber
                                                    .toString()
                                                    .padStart(2, '0')}
                                            </Element>
                                        )}
                                        <Element>{player.shortName}</Element>
                                    </Element>
                                </RouterLink>
                            </Level.Side>
                        </Level>
                    </List.Item>
                );
            })}
        </List>
    );
}
export default memo(BenchesList);
